/* eslint-disable */
// @ts-nocheck
import { BytesLike, BigNumber, BigNumberish } from 'ethers';
import { contract, Call, Send, AddressLike, Contract } from '@enzymefinance/ethers';



// prettier-ignore
export interface ITestCERC20 extends Contract<ITestCERC20> {
  accrueInterest: Send<() => BigNumber, ITestCERC20>
  'accrueInterest()': Send<() => BigNumber, ITestCERC20>
  allowance: Call<(owner: AddressLike, spender: AddressLike) => BigNumber, ITestCERC20>
  'allowance(address,address)': Call<(owner: AddressLike, spender: AddressLike) => BigNumber, ITestCERC20>
  approve: Send<(spender: AddressLike, amount: BigNumberish) => boolean, ITestCERC20>
  'approve(address,uint256)': Send<(spender: AddressLike, amount: BigNumberish) => boolean, ITestCERC20>
  balanceOf: Call<(account: AddressLike) => BigNumber, ITestCERC20>
  'balanceOf(address)': Call<(account: AddressLike) => BigNumber, ITestCERC20>
  borrow: Send<(_borrowAmount: BigNumberish) => BigNumber, ITestCERC20>
  'borrow(uint256)': Send<(_borrowAmount: BigNumberish) => BigNumber, ITestCERC20>
  borrowBalanceStored: Call<(_account: AddressLike) => BigNumber, ITestCERC20>
  'borrowBalanceStored(address)': Call<(_account: AddressLike) => BigNumber, ITestCERC20>
  decimals: Call<() => BigNumber, ITestCERC20>
  'decimals()': Call<() => BigNumber, ITestCERC20>
  exchangeRateStored: Call<() => BigNumber, ITestCERC20>
  'exchangeRateStored()': Call<() => BigNumber, ITestCERC20>
  mint: Send<(_mintAmount: BigNumberish) => BigNumber, ITestCERC20>
  'mint(uint256)': Send<(_mintAmount: BigNumberish) => BigNumber, ITestCERC20>
  redeem: Send<(_redeemAmount: BigNumberish) => BigNumber, ITestCERC20>
  'redeem(uint256)': Send<(_redeemAmount: BigNumberish) => BigNumber, ITestCERC20>
  repayBorrow: Send<(_repayAmount: BigNumberish) => BigNumber, ITestCERC20>
  'repayBorrow(uint256)': Send<(_repayAmount: BigNumberish) => BigNumber, ITestCERC20>
  totalSupply: Call<() => BigNumber, ITestCERC20>
  'totalSupply()': Call<() => BigNumber, ITestCERC20>
  transfer: Send<(recipient: AddressLike, amount: BigNumberish) => boolean, ITestCERC20>
  'transfer(address,uint256)': Send<(recipient: AddressLike, amount: BigNumberish) => boolean, ITestCERC20>
  transferFrom: Send<(sender: AddressLike, recipient: AddressLike, amount: BigNumberish) => boolean, ITestCERC20>
  'transferFrom(address,address,uint256)': Send<(sender: AddressLike, recipient: AddressLike, amount: BigNumberish) => boolean, ITestCERC20>
  underlying: Send<() => string, ITestCERC20>
  'underlying()': Send<() => string, ITestCERC20>
}

let ITestCERC20Bytecode: string | undefined = undefined;
if (typeof window === 'undefined') {
  ITestCERC20Bytecode = '0x';
}

// prettier-ignore
export const ITestCERC20 = contract<ITestCERC20>(ITestCERC20Bytecode)`
  event Approval(address indexed owner, address indexed spender, uint256 value)
  event Transfer(address indexed from, address indexed to, uint256 value)
  function accrueInterest() returns (uint256 amount_)
  function allowance(address owner, address spender) view returns (uint256)
  function approve(address spender, uint256 amount) returns (bool)
  function balanceOf(address account) view returns (uint256)
  function borrow(uint256 _borrowAmount) returns (uint256 amount_)
  function borrowBalanceStored(address _account) view returns (uint256 amount_)
  function decimals() view returns (uint8 decimals_)
  function exchangeRateStored() view returns (uint256 rate_)
  function mint(uint256 _mintAmount) returns (uint256 amount_)
  function redeem(uint256 _redeemAmount) returns (uint256 amount_)
  function repayBorrow(uint256 _repayAmount) returns (uint256 amount_)
  function totalSupply() view returns (uint256)
  function transfer(address recipient, uint256 amount) returns (bool)
  function transferFrom(address sender, address recipient, uint256 amount) returns (bool)
  function underlying() returns (address asset_)
`;